
export default function Modified()  {

    return (
        <div style={{ width:"100%", flexGrow: '1'}}>
            <iframe
                src="https://events.teamsnap.com/events/44336/results"
                width="100%"
                height="100%"
                name="TeamSnapEventsEmbeddedResults"
                id="TeamSnapEventsEmbeddedResults"
            ></iframe>
        </div>
    )
}
